import { Skeleton } from "antd";
import React from "react";

const ProjectListLoader = ({ numberOfSkeletons = 10 }) => {
    const renderSkeletons = () => {
        return Array.from({ length: numberOfSkeletons }, (_, index) => (
            <div
                key={index}
                className="flex gap-x-4 bg-white p-2 rounded-lg w-full mb-2"
            >
                <Skeleton.Image active={true} />
                <div className="flex flex-col justify-between w-full py-2">
                    <div className="flex gap-x-4">
                        <Skeleton.Button active={true} />
                        <Skeleton.Avatar active={true} />
                    </div>
                    <Skeleton.Button block={true} active={true} />
                </div>
            </div>
        ));
    };

    return <>{renderSkeletons()}</>;
};

export default ProjectListLoader;
